<div class="report-container">
  <div class="header-contents">
    <div class="filters-section">
      <app-custom-dropdown
        [(ngModel)]="selectedDropDownValue"
        (selectionChange)="onMonthYearChange($event)"
        [options]="dropDownData"
        trackBy="monthYear"
        label="Date"
      />
    </div>
  </div>

  <div class="classic-header">
    <table>
      <thead class="table-data">
        <tr>
          <th style="width: 40%"></th>
          @for (category of categories; track category) {
            <th class="header">
              {{ category }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Complete and Final Composites</td>
          @for (category of categories; track category + "-CFC") {
            <td>
              <div class="cell-content">
                @if (finalComposites[category]?.allowAccessXl) {
                  @if (finalComposites[category]?.excel) {
                    <a
                      [href]="finalComposites[category]?.excel"
                      target="_blank"
                      [title]="finalComposites[category]?.excelReportPath"
                    >
                      <img src="/assets/images/excel-active.png" alt="Excel" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img
                        src="/assets/images/excel-inactive.png"
                        alt="Excel"
                      />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-excel.svg"
                      alt="Excel access denied"
                    />
                  </span>
                }
                <span class="divider"></span>
                @if (finalComposites[category]?.allowAccessPdf) {
                  @if (finalComposites[category]?.pdf) {
                    <a
                      [href]="finalComposites[category]?.pdf"
                      target="_blank"
                      [title]="finalComposites[category]?.pdfReportPath"
                    >
                      <img src="/assets/images/pdf-active.svg" alt="Pdf" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img src="/assets/images/pdf-inactive.svg" alt="Pdf" />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-pdf.svg"
                      alt="PDF access denied"
                    />
                  </span>
                }
              </div>
            </td>
          }
        </tr>
        <tr>
          <td>My Trend Reports (Most Current and Archives)</td>
          @for (category of categories; track category + "-MTR") {
            <td>
              @if (myTrendsColumns.includes(category)) {
                <div class="cell-content">
                  @if (myTrends[category]?.allowAccess) {
                    @if (
                      myTrends[category]?.exists &&
                      myTrends[category]?.xmlReport
                    ) {
                      <a
                        [href]="myTrends[category].xmlReport"
                        target="_blank"
                        [title]="myTrends[category]?.report"
                      >
                        <img
                          src="/assets/images/excel-active.png"
                          alt="Excel"
                        />
                      </a>
                    } @else {
                      <span class="disabled">
                        <img
                          src="/assets/images/excel-inactive.png"
                          alt="Excel"
                        />
                      </span>
                    }
                  } @else {
                    <span>
                      <img
                        src="/assets/images/locked-excel.svg"
                        alt="Excel access denied"
                      />
                    </span>
                  }
                </div>
              }
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
  <div class="table-container">
    <div class="left-section">
      <table>
        <thead class="table-data">
          <tr>
            <th></th>
            <th class="header">Full Report</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Expense Absorption %</td>
            <td>
              <div class="cell-content">
                @if (expenseAbsorption?.allowAccessXl) {
                  @if (expenseAbsorption?.xlsexists) {
                    <a
                      [href]="expenseAbsorption?.xlsDownloadUrl"
                      target="_blank"
                    >
                      <img src="/assets/images/excel-active.png" alt="Excel" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img
                        src="/assets/images/excel-inactive.png"
                        alt="Excel"
                      />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-excel.svg"
                      alt="Excel access denied"
                    />
                  </span>
                }

                <span class="divider"></span>

                <!-- PDF Active -->
                @if (expenseAbsorption?.allowAccessPdf) {
                  @if (expenseAbsorption?.pdfexists) {
                    <a
                      [href]="expenseAbsorption?.pdfDownloadUrl"
                      target="_blank"
                    >
                      <img src="/assets/images/pdf-active.svg" alt="Pdf" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img src="/assets/images/pdf-inactive.svg" alt="Pdf" />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-pdf.svg"
                      alt="PDF access denied"
                    />
                  </span>
                }
              </div>
            </td>
          </tr>
          <tr>
            <td>Download Expense Reduction Report</td>
            <td>
              <div class="cell-content">
                @if (expenseReductionReports?.allowAccessXl) {
                  @if (expenseReductionReports?.xlsexists) {
                    <a
                      [href]="expenseReductionReports?.xlsDownloadUrl"
                      target="_blank"
                    >
                      <img src="/assets/images/excel-active.png" alt="Excel" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img
                        src="/assets/images/excel-inactive.png"
                        alt="Excel"
                      />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-excel.svg"
                      alt="excel access denied"
                    />
                  </span>
                }

                <span class="divider"></span>
                @if (expenseReductionReports?.allowAccessPdf) {
                  @if (expenseReductionReports?.pdfexists) {
                    <a
                      [href]="expenseReductionReports?.pdfDownloadUrl"
                      target="_blank"
                    >
                      <img src="/assets/images/pdf-active.svg" alt="Pdf" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img src="/assets/images/pdf-inactive.svg" alt="Pdf" />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-pdf.svg"
                      alt="PDF access denied"
                    />
                  </span>
                }
              </div>
            </td>
          </tr>
          <tr>
            <td>Gross Potential</td>
            <td>
              <div class="cell-content">
                @if (grossPotentials?.allowAccessXl) {
                  @if (grossPotentials?.xlsexists) {
                    <a [href]="grossPotentials?.xlsDownloadUrl" target="_blank">
                      <img src="/assets/images/excel-active.png" alt="Excel" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img
                        src="/assets/images/excel-inactive.png"
                        alt="Excel"
                      />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-excel.svg"
                      alt="excel access denied"
                    />
                  </span>
                }

                <span class="divider"></span>
                @if (grossPotentials?.allowAccessPdf) {
                  @if (grossPotentials?.pdfexists) {
                    <a [href]="grossPotentials?.pdfDownloadUrl" target="_blank">
                      <img src="/assets/images/pdf-active.svg" alt="Pdf" />
                    </a>
                  } @else {
                    <span class="disabled">
                      <img src="/assets/images/pdf-inactive.svg" alt="Pdf" />
                    </span>
                  }
                } @else {
                  <span>
                    <img
                      src="/assets/images/locked-pdf.svg"
                      alt="PDF access denied"
                    />
                  </span>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      @if (exprrAllow && outColumns.length) {
        <table>
          <thead>
            <tr class="table-data">
              <th colspan="4">Out of line Expenses</th>
            </tr>
            <tr class="expenses-second-header">
              @for (col of outColumns; track col) {
                <th
                  [class.highlight-my-data]="$index === 1"
                  [class.highlight-boc]="$index === 2"
                >
                  {{ col }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of outRows; track $index + "-row") {
              <tr>
                @for (col of outColumns; track $index + "-col") {
                  <td
                    [class.highlight-my-data]="$index === 1"
                    [class.highlight-boc]="$index === 2"
                  >
                    {{ row[$index] || "-" }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
    <div class="right-section">
      <table>
        <thead class="table-data">
          <tr>
            <th colspan="2" class="header">
              Files available (click on the link to download file)
            </th>
          </tr>
        </thead>

        <tbody>
          @for (item of groupCompositeReports; track item.label) {
            <tr>
              <td>{{ item.label }}</td>

              <td>
                @if (item.allowAccess) {
                  <!-- ACTIVE PDF -->
                  @if (item.exists && item.fileType === "pdf") {
                    <a
                      [href]="item.downloadUrl"
                      target="_blank"
                      [title]="item.label"
                    >
                      <img src="/assets/images/pdf-active.svg" alt="Pdf" />
                    </a>
                  }

                  <!-- ACTIVE EXCEL -->
                  @if (item.exists && item.fileType === "xlsx") {
                    <a
                      [href]="item.downloadUrl"
                      target="_blank"
                      [title]="item.label"
                    >
                      <img src="/assets/images/excel-active.png" alt="Excel" />
                    </a>
                  }

                  <!-- INACTIVE PDF -->
                  @if (!item.exists && item.fileType === "pdf") {
                    <span class="disabled" [title]="item.label">
                      <img src="/assets/images/pdf-inactive.svg" alt="Pdf" />
                    </span>
                  }

                  <!-- INACTIVE EXCEL -->
                  @if (!item.exists && item.fileType === "xlsx") {
                    <span class="disabled" [title]="item.label">
                      <img
                        src="/assets/images/excel-inactive.png"
                        alt="Excel"
                      />
                    </span>
                  }
                } @else {
                  <span>
                    @if (item.fileType === "pdf") {
                      <img
                        src="/assets/images/locked-pdf.svg"
                        alt="PDF access denied"
                      />
                    }
                    @if (item.fileType === "xlsx") {
                      <img
                        src="/assets/images/locked-excel.svg"
                        alt="Excel access denied"
                      />
                    }
                  </span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
